/**
 * The haptics call, for components (`src/lib/haptics.ts`).
 *
 * A hook rather than a bare import so the seam stays in one place a test or a
 * native shell can reason about, and so a component never imports `lib/`
 * directly for a UI concern.
 */

import { haptics, type HapticKind } from "@/lib/haptics";

export function useHaptics(): (kind: HapticKind) => void {
  return haptics;
}
